import React from 'react'
import { Link, useStaticQuery } from 'gatsby'
import { graphql } from "gatsby"
import Img from "gatsby-image"

const TalePreview = () => {
    const data = useStaticQuery(graphql`
    query MyQueryTale {
        file(relativePath: {eq: "count_min.png"}) {
          childImageSharp {
            fluid (quality: 90){
              aspectRatio
              base64
              sizes
              src
              srcSet
            }
          }
        }
      }`
    )

    return (
        <div className="tale">
            <section className="inner">
                <div className="row">
                    <div className="col-md">
                        <Img
                            fluid={data.file.childImageSharp.fluid}
                            alt="TaleImage"
                        />
                    </div>
                    <div className="col-md">
                        <h1 className="pf mt-3"><strong>Conto autoral | Banquete</strong></h1>
                        <i>
                            <p>Na mesa de madeira, o cardume de luz encontra um lago espelhado após seu mergulho do lustre de cristal. Se esconde embaixo dos pratos e terrinas brancos com frisos dourados, ou então nada ligeiro através dos talheres e taças. Ao seu lado, ele comenta sobre a beleza do arranjo e a delicadeza da porcelana com a voz erodida por décadas de cigarro. Ela apenas concorda, estendendo o guardanapo sobre o colo.</p>
                        </i>
                        <Link to="/conto-autoral">
                            <p><i className="icon fa-plus-circle"></i> Continue lendo</p>
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default TalePreview
